import common from './common'

export default {
  ...common.button,
  color: `omegaDark`,
  bg: `mute`,
  borderColor: `mute`,
  ':hover': {
    color: `background`,
    bg: `alpha`,
    borderColor: `alpha`
  }
}
